import Vue from 'vue'
import Config from '@/config'

let resource = null

const actions = {
  triggerReadinessChecker: {
    method: 'POST',
    url: `${Config.publicLanggraphApiUrl}/ahaslides/api/readiness-checker/run`,
  },

  getReadinessPotentialIssues: {
    method: 'GET',
    url: `${Config.baseUrl}/api/readiness-checker/issues?presentationId={presentationId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const triggerReadinessChecker = async ({ presentationId }) => {
  if (!resource) initResource()

  const res = await resource.triggerReadinessChecker({ presentationId })
  return res.body
}

const getReadinessPotentialIssues = async ({ presentationId }) => {
  if (!resource) initResource()

  const res = await resource.getReadinessPotentialIssues({ presentationId })
  return res.body.issues
}

export default {
  initResource,
  triggerReadinessChecker,
  getReadinessPotentialIssues,
}
